module.exports = __webpack_public_path__ + "static/media/landscape-cropx2.e6f11251.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/default-img-listing/landscape-cropx2.webp
// module id = 815
// module chunks = 0